import {computed} from "mobx";
import {METADATA_FILTERS} from "../../../../../core/models/metatdata/metadata-filters.consts";
import {CompetitionPageMetaDataModel} from "../../../models/competition-page.meta-data.model";

export class CompetitionMatchesPageRouteMetaDataModel extends CompetitionPageMetaDataModel {
  @computed get pageTitle() {
    let title = this.staticTitle;

    if (this.titleSection) {
      title = this.titleSection.getElementValue(METADATA_FILTERS.COMPETITION.matches)
    }

    return title
  }

  @computed get description(): String {
    let description = this.staticDescription;

    if (this.descriptionSection) {
      description = this.descriptionSection.getElementValue(METADATA_FILTERS.COMPETITION.matches)
    }

    return description
  }

  get staticTitle() {
    const staticTitle = this.websiteTerms[`META_TITLE_COMPETITION_MATCHES_${this.competitionId}`] || this.websiteTerms.COMPETITION_MATCHES_TITLE_TEMPLATE

    return staticTitle.format({
      COMPETITION_NAME: this.competitionName,
      COMPETITION_CURRENT_YEAR: this.competitionCurrentYear,
    });
  }

  get staticDescription() {
    const matchesDescription = (this.websiteTerms[`META_DESCRIPTION_COMPETITION_MATCHES_${this.competitionId}`] || this.websiteTerms.COMPETITION_MATCHES_DESCRIPTION_TEMPLATE).format({
      "COMPETITION_NAME": this.competitionName,
      "COMPETITION_CURRENT_YEAR": this.competitionCurrentYear,
    });

    return matchesDescription;
  }

  get canonicalUrl(): String {
    const canonicalUrl: String = super.canonicalUrl.split('/').slice(0, -1).join('/');

    return canonicalUrl
  }
}